import { useQuery } from '@tanstack/react-query';
import { getCart } from '../../api/apiStorefront';

export const useGetCart = () => {
  const {
    data,
    isLoading,
    isFetching,
    error,
    refetch,
    dataUpdatedAt,
  } = useQuery({
    queryKey: ['cart'],
    queryFn: getCart,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 1,
  });

  const cartData = data?.data?.data || null;

  // dataUpdatedAt is a millisecond timestamp set every time the query
  // resolves successfully (including via invalidate-after-mutation).
  // The "Saved just now" indicator reads this directly.
  return { isLoading, isFetching, error, cartData, refetch, dataUpdatedAt };
};
